export default [
  {
    path: '/admin/adFormats',
    name: 'ad-formats',
    component: () => import('@/views/admin/ad-types/AdFormats.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.AdFormats',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.AdFormats',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/nativeads',
    name: 'admin-nativeads',
    component: () => import('@/views/admin/ad-types/NativeAds.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.NativeAds',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.NativeAds',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/nativeads/edit/:id',
    name: 'admin-nativeads-edit',
    component: () => import('@/views/admin/ad-types/NativeAdsProperties.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.NativeAds.Edit',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.NativeAds',
          to: '/admin/nativeads',
        },
        {
          text: 'Admin.SideMenu.Navigation.NativeAds.Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/displayads',
    name: 'admin-displayads',
    component: () => import('@/views/admin/ad-types/DisplayAds.vue'),
    meta: {
      pageTitle: 'Admin.SideMenu.Navigation.DisplayAds',
      breadcrumb: [
        {
          text: 'ClientPortal.SideMenu.Admin',
          active: true,
        },
        {
          text: 'Admin.SideMenu.Navigation.DisplayAds',
          active: true,
        },
      ],
    },
  },
]
